import { useEffect } from 'react';
import { META_PIXEL_ID } from '../data/config';
export function MetaPixel() {
  useEffect(() => {
    if (!META_PIXEL_ID) return;
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  if (!META_PIXEL_ID) return null;
  return <noscript data-id="element-209" data-mp="22yb5bjz622g6">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-210" data-mp="22xt223e36nyr" />
    </noscript>;
}